import { Component, HostListener, OnInit } from '@angular/core';
import Swal from 'sweetalert2';

import { users } from '../../../../interfaces/users';
import { UserService } from '../../../../services/user';
import { DeliveryService } from '../../../../services/delivery';
import { ItemsService } from '../../../../services/items.service';

interface DayCalendarItem {
  date: Date;
  dayNumber: string;
  isCurrentMonth: boolean;
  isToday: boolean;
  isSelected: boolean;
  isDisabled: boolean;
}

@Component({
  selector: 'app-deliveryherocollectingmobile',
  templateUrl: './deliveryherocollectingmobile.component.html',
  styleUrl: './deliveryherocollectingmobile.component.scss'
})
export class DeliveryherocollectingmobileComponent implements OnInit {

  userData!: users;

  contentReady: boolean = true;
  isLoadingMore: boolean = false;

  collectedFromDH: any[] = [];

  herosd: any;
  date: any;

  heros: any[] = [];
  allWareHouses: any[] = [];

  isAr: boolean = false;

  accountType!: string;
  isAdmin: boolean = false;
  isMobile: boolean = true;
  isSubAdmin: boolean = false;

  hasData: boolean = false;

  totalCollected: number = 0;
  totalAmount: number = 0;
  totalCount: number = 0;

  currentPage: number = 1;
  lastPage: number = 1;
  totalItems: number = 0;
  pageSize: number = 10;

  warehouseId: any;

  // لما المستخدم يفلتر باليوم أو الدليفري، هنوقف infinite scroll
  isFiltering: boolean = false;

  showDayCalendar: boolean = false;
  dayCalendarViewDate: Date = new Date();

  constructor(
    private _userService: UserService,
    private _ItemsService: ItemsService,
    private _deliveryhero: DeliveryService
  ) { }

  ngOnInit(): void {
    this.isAr = this.getStorageValue('language') === 'ar';
    this.warehouseId = this.getStorageValue('posId');

    this.date = this.getTodayDate();

    const today = this.parseDateOnly(this.date) || new Date();
    this.dayCalendarViewDate = new Date(today.getFullYear(), today.getMonth(), 1);

    this.getWarehouses();
    this.getAccountType();

    this.getallFromHeros(this.warehouseId, 1, false);
    this.getAllHeros(this.warehouseId, false);
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    if (typeof window === 'undefined') return;

    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const windowHeight = window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;

    const bottomReached = scrollPosition + windowHeight >= pageHeight - 120;

    if (bottomReached) {
      this.loadMore();
    }
  }

  getWarehouses(): void {
    this._ItemsService.getWearHouses().subscribe({
      next: (res: any) => {
        this.allWareHouses = res?.warehouse || [];
      },
      error: (error) => console.error(error)
    });
  }

  getAccountType(): void {
    this._userService.getAccountType().subscribe({
      next: (data: any) => {
        this.accountType = data['user_type'];
        this.isAdmin = this.accountType === '1' || this.accountType === '10';
        this.isSubAdmin = this.accountType === '6';
      },
      error: (error) => console.error(error)
    });
  }

  applyWareHouse(warehouseId: any): void {
    this.warehouseId = warehouseId;
    this.currentPage = 1;
    this.lastPage = 1;
    this.isFiltering = false;

    this.getallFromHeros(this.warehouseId, 1, false);
    this.getAllHeros(this.warehouseId, false);
  }

  getAllHeros(warehouse_id: any, hasPagination: boolean): void {
    this.contentReady = true;

    this._deliveryhero.getAllDeliveryStars(warehouse_id, hasPagination).subscribe({
      next: (data: any) => {
        this.heros = data || [];

        if (this.heros.length > 0) {
          this.herosd = this.heros[0].link ?? this.heros[0].phone ?? this.heros[0].id;
        }

        this.contentReady = false;
      },
      error: (error) => {
        console.error(error);
        this.contentReady = false;
      }
    });
  }

  getallFromHeros(warehouse_id: any, page: number = 1, append: boolean = false): void {
    if (append) {
      this.isLoadingMore = true;
    } else {
      this.contentReady = true;
    }

    this._deliveryhero
      .getAllDeliveryCollections(warehouse_id, page, this.pageSize)
      .subscribe({
        next: (res: any) => {
          const rows = res?.data || [];

          this.collectedFromDH = append
            ? [...this.collectedFromDH, ...rows]
            : rows;

          this.currentPage = Number(res?.current_page || page);
          this.lastPage = Number(res?.last_page || 1);
          this.totalItems = Number(res?.total || this.collectedFromDH.length);

          this.totalCount = Number(res?.total_orders_month || this.collectedFromDH.length);
          this.totalAmount = Number(res?.total_amount_month || this.sumAmounts(this.collectedFromDH));

          this.recalcSummary();

          this.hasData = this.collectedFromDH.length === 0;

          this.contentReady = false;
          this.isLoadingMore = false;
        },
        error: (err) => {
          console.error(err);
          this.contentReady = false;
          this.isLoadingMore = false;
        }
      });
  }

  loadMore(): void {
    if (this.contentReady) return;
    if (this.isLoadingMore) return;
    if (this.isFiltering) return;
    if (this.currentPage >= this.lastPage) return;

    this.getallFromHeros(this.warehouseId, this.currentPage + 1, true);
  }

  dayChange(): void {
    this.isFiltering = true;
    this.closeDayCalendar();
    this.getCollectedFromHero();
  }

  filterAllHeros(): void {
    this.isFiltering = true;
    this.getCollectedFromHero();
  }

  getCollectedFromHero(): void {
    this.contentReady = true;

    this._deliveryhero
      .getAllDeliveryCollections(parseInt(this.herosd), this.date)
      .subscribe({
        next: (data: any) => {
          this.collectedFromDH = data?.data || [];

          this.totalCount = this.collectedFromDH.length;
          this.totalAmount = this.sumAmounts(this.collectedFromDH);

          this.recalcSummary();

          this.hasData = this.collectedFromDH.length === 0;

          this.contentReady = false;
        },
        error: (error) => {
          console.error(error);
          this.contentReady = false;
        }
      });
  }

  delete(id: any): void {
    Swal.fire({
      title: this.isAr ? 'متأكد؟؟' : 'Are You Sure?',
      showCancelButton: true,
      confirmButtonText: this.isAr ? 'اه' : 'YES',
      cancelButtonText: this.isAr ? 'لا' : 'no'
    }).then((result) => {
      if (result.isConfirmed) {
        this.contentReady = true;

        this._deliveryhero.deleteDeliveryCollection(id).subscribe({
          next: () => {
            if (this.isFiltering) {
              this.getCollectedFromHero();
            } else {
              this.getallFromHeros(this.warehouseId, 1, false);
            }
          },
          error: (err) => {
            console.error(err);
            this.contentReady = false;
          }
        });
      }
    });
  }

  recalcSummary(): void {
    this.totalCollected = this.sumAmounts(this.collectedFromDH);
  }

  sumAmounts(items: any[]): number {
    return (items || []).reduce((acc: number, item: any) => {
      return acc + Number(item?.amount_collected || 0);
    }, 0);
  }

  formatDeliveryHero(value: any): string {
    const raw = String(value ?? '').trim();

    if (!raw) return '-';

    return raw.startsWith('0') ? raw : `0${raw}`;
  }

  trackByCollection(index: number, item: any): any {
    return item?.id || item?.order_id || index;
  }

  getTodayDate(): string {
    return this.formatDateForInput(new Date());
  }

  private getStorageValue(key: string): string | null {
    if (typeof localStorage === 'undefined') return null;
    return localStorage.getItem(key);
  }

  /* ================================
     Day Calendar
     نفس Calendar بتاع New Booking
     ================================ */

  toggleDayCalendar(): void {
    this.showDayCalendar = !this.showDayCalendar;

    if (this.showDayCalendar) {
      const selectedDate = this.parseDateOnly(this.date);
      const baseDate = selectedDate || new Date();

      this.dayCalendarViewDate = new Date(
        baseDate.getFullYear(),
        baseDate.getMonth(),
        1
      );
    }
  }

  closeDayCalendar(): void {
    this.showDayCalendar = false;
  }

  previousDayCalendarMonth(): void {
    this.dayCalendarViewDate = new Date(
      this.dayCalendarViewDate.getFullYear(),
      this.dayCalendarViewDate.getMonth() - 1,
      1
    );
  }

  nextDayCalendarMonth(): void {
    this.dayCalendarViewDate = new Date(
      this.dayCalendarViewDate.getFullYear(),
      this.dayCalendarViewDate.getMonth() + 1,
      1
    );
  }

  getDayCalendarTitle(): string {
    return new Intl.DateTimeFormat(this.isAr ? 'ar-EG' : 'en-US', {
      month: 'long',
      year: 'numeric',
    }).format(this.dayCalendarViewDate);
  }

  getDayCalendarWeekDays(): string[] {
    return this.isAr
      ? ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
      : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  }

  getDayCalendarDays(): DayCalendarItem[] {
    const year = this.dayCalendarViewDate.getFullYear();
    const month = this.dayCalendarViewDate.getMonth();

    const firstDay = new Date(year, month, 1);
    const gridStart = new Date(year, month, 1 - firstDay.getDay());

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const selectedDate = this.parseDateOnly(this.date);

    return Array.from({ length: 42 }, (_, index) => {
      const date = new Date(gridStart);
      date.setDate(gridStart.getDate() + index);
      date.setHours(0, 0, 0, 0);

      return {
        date,
        dayNumber: this.isAr ? this.toArabicDigits(date.getDate()) : String(date.getDate()),
        isCurrentMonth: date.getMonth() === month,
        isToday: this.isSameDate(date, today),
        isSelected: selectedDate ? this.isSameDate(date, selectedDate) : false,

        // التحصيلات ممكن تحتاج تواريخ قديمة
        isDisabled: false
      };
    });
  }

  selectDayCalendarDate(date: Date): void {
    const selectedDate = new Date(date);
    selectedDate.setHours(0, 0, 0, 0);

    this.date = this.formatDateForInput(selectedDate);

    this.dayChange();
  }

  getDayDisplay(): string {
    const selectedDate = this.parseDateOnly(this.date);

    if (!selectedDate) {
      return this.isAr ? 'اختار اليوم' : 'Select day';
    }

    return new Intl.DateTimeFormat(this.isAr ? 'ar-EG' : 'en-US', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(selectedDate);
  }

  private parseDateOnly(value: any): Date | null {
    if (!value) return null;

    const cleanValue = String(value)
      .replace('T', ' ')
      .replace('Z', '')
      .split('.')[0]
      .trim()
      .split(' ')[0];

    const match = cleanValue.match(/^(\d{4})-(\d{2})-(\d{2})$/);

    if (!match) return null;

    return new Date(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3])
    );
  }

  private isSameDate(first: Date, second: Date): boolean {
    return first.getFullYear() === second.getFullYear() &&
      first.getMonth() === second.getMonth() &&
      first.getDate() === second.getDate();
  }

  private formatDateForInput(date: Date): string {
    return [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, '0'),
      String(date.getDate()).padStart(2, '0'),
    ].join('-');
  }

  private toArabicDigits(value: string | number): string {
    return String(value).replace(/\d/g, (digit) => '٠١٢٣٤٥٦٧٨٩'[Number(digit)]);
  }

}